import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { School, FileText, UserPlus, FileCode2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';

export const DevDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <PageHeader
        title="Dev Team Dashboard"
        subtitle="Manage schools, view audit logs, and invite team members"
      />
      
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
        <Card hover onClick={() => navigate(ROUTES.DEV_SCHOOLS)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-primary-100 dark:bg-primary-900 rounded-lg">
                <School className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <CardTitle>Schools</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 dark:text-gray-400">
              View and manage all schools in the platform
            </p>
          </CardContent>
        </Card>

        <Card hover onClick={() => navigate(ROUTES.DEV_AUDIT_LOGS)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-secondary-100 dark:bg-secondary-900 rounded-lg">
                <FileText className="w-6 h-6 text-secondary-600 dark:text-secondary-400" />
              </div>
              <CardTitle>Audit Logs</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 dark:text-gray-400">
              View system audit logs and events
            </p>
          </CardContent>
        </Card>

        <Card hover onClick={() => navigate(ROUTES.DEV_INVITE)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-accent-100 dark:bg-accent-900 rounded-lg">
                <UserPlus className="w-6 h-6 text-accent-600 dark:text-accent-400" />
              </div>
              <CardTitle>Invite Dev Team</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 dark:text-gray-400">
              Invite new dev team members
            </p>
          </CardContent>
        </Card>

        <Card hover onClick={() => navigate(ROUTES.DEV_PROMPT_TEMPLATES)} className="cursor-pointer">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-primary-100 dark:bg-primary-900 rounded-lg">
                <FileCode2 className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <CardTitle>Prompt library</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 dark:text-gray-400">
              Create and manage AI Tutor prompts in MongoDB
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

